module.exports = __webpack_public_path__ + "media/assets/images/votorantim-energia-ba5104a60e0bf0878eb467fc5118027e.png";